import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import includes from 'lodash/includes'
import find from 'lodash/find'
import Select from 'react-select'

class EditStatus extends React.Component {
  constructor (props) {
    super(props)
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT', role: ['admin'] },
      { value: 'payment-pending', label: 'PENDING', role: ['admin', 'finance', 'cs'] },
      { value: 'approved-cs', label: 'APPROVED CS', role: ['admin', 'cs'] },
      { value: 'payment-failed', label: 'FAILED', role: ['admin', 'finance'] },
      { value: 'canceled', label: 'CANCELED', role: ['admin', 'finance'] },
      { value: 'expired', label: 'EXPIRED', role: ['admin'] }
    ]

    let options = []
    this.orderStatus.map((status, i) => {
      if (includes(status.role, this.props.role)) {
        options.push(status)
      }
      return options
    })

    this.options = options

    let {
      status
    } = props.detail

    status = find(this.options, function (i) { return i.value === status })

    this.state = {
      status
    }
  }

  _fieldChange = (event, field) => {
    let val = event.target.value
    let newState = { ...this.state }
    if (event.target.type === 'number') {
      val = parseFloat(val)
    }
    newState[field] = val
    this.setState(newState)
  }

  _submit = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id,
      form: {
        status: this.state.status.value
      }
    }

    this.props.submit(data)
    this.props.closeModal()
  }

  render () {
    const { order, detail } = this.props

    return (
      <form onSubmit={(event) => this._submit(event)} className='section' style={{ width: '30vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Edit Status <div className='badge badge-secondary ml-2'>{detail.order_number}</div>
            {
              (order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>

        <div className='form-group' style={{ position: 'relative' }}>
          <label className='control-label'>Status</label>
          <Select options={this.options} value={this.state.status} required onChange={(status) => this.setState({ status })} />
          <input value={this.state.status} required onChange={() => null} style={{ position: 'absolute', zIndex: '-1', top: '50%', left: '30%' }} />
        </div>

        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
          <button type='submit' className='btn btn-lg btn-primary'>Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order,
  role: state.auth.user.role
})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(OrderActions.orderUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EditStatus)



// WEBPACK FOOTER //
// ./src/Containers/Order/EditStatus.js